export default __webpack_public_path__ + "static/media/img_result_sample.415beedc.png";